import { Router } from '@angular/router';
import { NodeConnectionNames, NodeConnection } from "dto/NodeConnection";
import { ElementRef, OnInit, Input, Component } from "@angular/core";
import { ApiService } from "services/api.service";
import { UiElementType } from "classes/UIElementType";
import { NodeUi } from "classes/NodeUi";
import { NgbdModalContent } from "app/node-info/node-info.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NodeTypes } from "dto/MetadataDto";

@Component({
  selector: 'node',
  templateUrl: './node.component.html',
  styleUrls: ['./node.component.css']
})
export class NodeComponent implements OnInit {
  
  UIElementType = UiElementType;
  NodeTypes = NodeTypes
  @Input() node: NodeUi;
  outputs:NodeConnection[];
  constructor(private el:ElementRef, private modalService: NgbModal, private api:ApiService,private router: Router) { }
  ngOnInit() {

  }

  open() {
    const modalRef = this.modalService.open(NgbdModalContent);
    //todo: validate -> what if not UserInterfaceElementDto?
    modalRef.componentInstance.node = this.node;
    modalRef.result.then((result) => {
      //popup closed normaly -> tell the world this node is changed.
      this.node.Flow.Refresh();
    }, (reason) => {
      //popup dismissed (by clicking backdrop or hitting ESC) -> tell the world not to update.
      this.node.Flow.Refresh();
    });
  }

  mouseOver(){

    //TODO: Replace highlight mechanism with a more generic way to add CSS classes.
    this.node.Highlight = true;
    this.node.GetEndOfThisGroup().Connections.filter(connection => connection.Dto.Identifier == this.node.dto.Identifier && connection.Dto.Name != NodeConnectionNames.ALWAYS_TRIGGERED).forEach(connection => {
        connection.Highlight = true;
    });
    // Highlight the target of a GoToNode
    if (this.node.dto.NodeType == NodeTypes.GoToNode)
      this.node.Flow.Nodes.find(target => target.dto.Identifier == this.node.dto.TemplateValues.NodeId).Highlight = true;
  }

  mouseOut(){
    this.node.Highlight = false;
    this.node.GetEndOfThisGroup().Connections.filter(connection => connection.Dto.Identifier == this.node.dto.Identifier && connection.Dto.Name != NodeConnectionNames.ALWAYS_TRIGGERED).forEach(connection => {
        connection.Highlight = false;
    });
    if (this.node.dto.NodeType == NodeTypes.GoToNode)
      this.node.Flow.Nodes.find(target => target.dto.Identifier == this.node.dto.TemplateValues.NodeId).Highlight = false;
  }

  toSubflow(event:any){
    event.stopPropagation();
    this.router.navigate(['/fetch-data',this.node.dto.TemplateValues.FlowId]);

  }
}


// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/node/node.component.ts